export default __webpack_public_path__ + "static/social_yes_studio-a22f71690cb497308c5a58382618fd08.png";